<style>
    ol, ul{
        margin-left: 1.25rem !important;
    }
    ol {
        list-style-type: decimal !important;
    }
    ul {
        list-style-type: disc !important;
    }
</style>

<template>
    <layout-internal-container>
        <div v-if="programDetail" class="w-full grid bg-white grid-cols-12 gap-10 md:gap-12 rounded-xl">
            <div class="flex flex-col md:col-span-8 col-span-12 gap-8">
                <div class="flex flex-col md:flex-row justify-between md:items-end gap-8 md:gap-0 w-full">
                    <img :src="programDetail.photo" class="inline md:hidden h-24 w-24 object-cover rounded-full" alt="">
                    <div class="flex flex-row gap-8 items-center">
                        <img :src="programDetail.photo" class="hidden md:inline h-24 w-24 object-cover rounded-full" alt="">
                        <div class="flex flex-col gap-4">
                            <span class="text-3xl font-medium">{{ programDetail.title }}</span>
                            <span class="text-sm font-light leading-relaxed">{{ programDetail.short_desc }}</span>
                            <div class="flex flex-row flex-wrap font-sans gap-4 items-center">
                                <span class="flex w-fit text-[.7rem] bg-[#e6e4dc] px-3 py-1 items-center">{{
                                    programDetail.type
                                }}</span>
                                <span class="flex w-fit text-[.7rem] bg-[#e6e4dc] px-3 py-1 items-center">{{ programDetail.batch.toUpperCase() }}</span>
                                <span class="text-[.7rem] px-3 py-1 flex items-center font-medium"
                                    :class="programDetail.status === 'Upcoming' ? 'bg-[#40BD3C] text-[#e6e4dc]' : (programDetail.status === 'Ended' ? 'bg-[#ef4444] text-[#e6e4dc]' : 'bg-[#0668e7] text-[#e6e4dc]')"
                                >
                                    <a-badge :color="programDetail.status === 'Upcoming' ? '#fff' : '#fff'" />
                                    {{ programDetail.status === 'Upcoming' ? 'Awaiting' : programDetail.status }}
                                </span>
                                <div class="flex flex-row gap-2 text-light items-center">
                                    <IconCalendarStats :stroke-width="1.5" :size="18" />
                                    <span class="text-xs">{{ defaultFormatDate(programDetail.start_date) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <a-tabs v-model:activeKey="tab" class="w-full">
                    <a-tab-pane :key="0" tab="Overview">
                        <div class="flex flex-col gap-3">
                            <div class="flex flex-col gap-2 text-[.9rem] font-light leading-loose" v-html="sanitizedDesc(programDetail?.desc)">
                            </div>
                            <div class="flex w-full flex-col gap-3"  v-if="JSON.parse(programDetail?.benefit).length > 0 && JSON.parse(programDetail?.benefit)[0]?.value_benefit != null">
                                <span class="font-medium text-base">Benefit</span>
                                <div class="w-full grid grid-cols-2 xl:grid-cols-3 gap-3">
                                    <div class="full bg-white p-5 gap-3 md:gap-5 md:items-center border-r flex flex-col md:flex-row" v-for="(benefit, indexBenefit) in JSON.parse(programDetail.benefit)" :key="indexBenefit">
                                        <i :class="benefit.icon_benefit" class="text-primary min-w-min" :size="32"></i>
                                        <span class="text-sm leading-relaxed">{{ benefit.value_benefit }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane :key="1" tab="Course">
                        <div class="flex flex-col gap-4">
                            <span class="font-semibold text-base">Course By {{ programDetail.title }}</span>
                            <!-- <div class="w-full gap-4 grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2"> -->
                                <a-collapse expandIconPosition="end"
                                    v-model:activeKey="activeKey"
                                    style="border-bottom: 2px solid #e6e7eb; border-radius: 0;" ghost
                                    v-for="(category, index) in categoryCourses" :key="index">
                                    <a-collapse-panel :key="category?.courses[0]?.category_id ?? index" :collapsible="isNotAccessibleDate(category) ? 'disabled' : ''">
                                        <div class="w-full gap-4 flex flex-nowrap pb-4 relative" :class="category.status == 'Pending' ? 'overflow-hidden' : 'overflow-auto'">
                                            <div
                                                v-for="(item, indexCardCourse) in category.courses"
                                                :key="item.id"
                                                class="max-w-[20rem] flex-none"
    >
                                                <card-course
                                                    :title="(indexCardCourse + 1) + '. ' + item.title" 
                                                    :duration="item.duration"
                                                    :rating="item.rating" 
                                                    :image="item.photo" 
                                                    :enroll="item.total_reviews" 
                                                    :lesson="item.total_lessons"
                                                    :completed="item.total_completed"
                                                    :finished="item.finished_percentage"
                                                    :id="item.id" 
                                                    :featured="item.featured"
                                                    :category="item.category" 
                                                    :speakerName="item.speaker_name"
                                                    :speakerPhoto="item.speaker_photo"
                                                    :enrolled="item.isEnrolled"     
                                                    :slug="item.slug"
                                                    :isFree="item.program_id == null"
                                                />
                                            </div>

                                            <div
                                               v-if="category.status == 'Pending'"
                                                class="absolute inset-0 bg-white/30 backdrop-blur-sm z-10 flex flex-col gap-2 items-center justify-center"
                                            >
                                                <div class="bg-gray-50 shadow rounded-xl p-12 flex gap-4 flex-col items-center justify-center">
                                                    <IconLock :size="100" class="text-yellow-600" />
                                                    <p class="text-yellow-600 text-xl font-medium">Complete the previous category to access this category's courses.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <template #header>
                                            <div class="flex flex-col gap-1">
                                                <span class="font-semibold text-base">{{ index + 1 }}. {{ category.name }}</span>

                                                <span class="flex items-center gap-1 text-xs font-bold text-primary w-auto" v-if="category.status == 'Completed'">Completed <IconChecklist :size="18"/></span>
                                                <span class="flex items-center gap-1 text-xs font-bold text-sky-700 w-auto" v-else-if="category.status == 'Ongoing'">Ongoing <IconHourglass :size="18"/></span>
                                                <span class="flex items-center gap-1 text-xs font-bold text-red-700 w-auto" v-else-if="category.status == 'Not Accessible'">Not Accessible <IconLock :size="18"/></span>
                                                <span class="flex items-center gap-1 text-xs font-bold text-yellow-600 w-auto" v-else-if="category.status == 'Pending'">Pending <IconClockCancel :size="18"/></span>
                                            </div>
                                        </template>
                                    </a-collapse-panel>
                                    
                                    <template #expandIcon="{ isActive }">
                                        <a-tooltip placement="top" :arrow="mergedArrow" v-if="isNotAccessibleDate(category)">
                                            <template #title>
                                                <span class="text-center block">Open on {{ defaultFormatDate(category.start_date) }}</span>
                                            </template>

                                            <IconInfoCircle class="text-black cursor-pointer" :size="18" stroke-width="2.5"/>
                                        </a-tooltip>

                                        <div v-else>
                                            <IconChevronDown :size="15" stroke-width="2.5" v-if="isActive"/>
                                            <IconChevronRight :size="15" stroke-width="2.5" v-else />
                                        </div>
                                    </template>
                                </a-collapse>
                            <!-- </div> -->
                        </div>
                    </a-tab-pane>
                    <a-tab-pane :key="2" tab="Webinar">
                        <div class="flex flex-col gap-6">
                            <template v-if="Object.keys(webinars).length > 0">
                                <div class="space-y-6" v-for="(item, date) in webinars" :key="date">
                                    <span class="text-lg font-medium">{{ moment(date).format('MMM YYYY') }}</span>
                                    <div v-for="(webinar, index) in item" :key="index"
                                        class="flex flex-col md:flex-row border px-4 py-8">
                                        <div
                                            class="flex flex-col items-center justify-center md:border-r px-6 pb-8 md:pb-0 md:px-6 text-primary gap-1">
                                            <span class="text-xs">Day</span>
                                            <span class="text-3xl font-medium">{{ moment(webinar.date).format('D') }}</span>
                                        </div>

                                        <div
                                            class="flex flex-col md:flex-row md:items-center md:justify-between flex-grow md:gap-8 md:pl-6 pr-0">
                                            <div class="space-y-2">
                                                <span class="text-sm font-medium">{{ webinar.title }}</span>
                                                <div class="flex flex-wrap gap-4 items-center text-sm text-gray-500">
                                                    <div class="flex items-center gap-2">
                                                        <img :src="webinar.program.photo" class="h-6 w-6 rounded-md object-cover"
                                                            alt="">
                                                        <span>{{ webinar.program.title }}</span>
                                                    </div>
                                                    <div class="flex items-center gap-2">
                                                        <IconClockHour3Filled class="text-gray-300" :size="20"
                                                            stroke-width="1.8" />
                                                        <span>{{ webinar.time_start }} - {{ webinar.time_end }}</span>
                                                    </div>
                                                    <!-- <div v-if="webinar.status === 'Ongoing'"
                                                        class="flex items-center gap-2 text-primary">
                                                        <div class="h-2 w-2 bg-primary rounded-full"></div>
                                                        <span class="font-medium">Live Now</span>
                                                    </div> -->
                                                    <div v-if="
                                                        isBetweenDateTime(webinar.date, webinar.time_start, webinar.time_end)
                                                        "
                                                        class="flex items-center gap-2 text-primary">
                                                        <div class="h-2 w-2 bg-primary rounded-full"></div>
                                                        <span class="font-medium">Live Now</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="flex md:justify-end mt-8 md:mt-0 md:ml-auto">
                                                <!-- <div v-if="isBetweenDateTime(webinar.date, webinar.time_start, webinar.time_end)">
                                                    <a-button @click="openWebinar" type="primary">Join Now</a-button>
                                                </div>
                                                <div v-if="isBeforeDateTime(webinar.date, webinar.time_start, webinar.time_end)">
                                                    <a-button @click="$router.push('/Internal/Calendar?action=webinar')">Set
                                                        Reminder</a-button>
                                                </div> -->
                                                
                                                <a-button @click="openWebinar(webinar.link_room)" type="primary">Join Now</a-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <div class="w-full gap-2 flex flex-col items-center justify-center mt-8" v-else>
                                <p>There isn't webinar yet.</p>
                            </div>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane :key="3" tab="Mentor">
                        <div class="flex flex-col gap-4">
                            <span class="font-semibold text-base">Mentor At {{ programDetail.title }}</span>
                            <div class="w-full grid gap-4 md:grid-cols-2" v-if="coaches.length > 0">
                                <div v-for="item in coaches" :key="item" class="border flex flex-col">
                                    <div class="flex flex-rows gap-3 p-3">
                                        <img class="h-20 w-20 object-cover"
                                            :src="item.coach.photo"
                                            alt="">
                                        <div class="flex flex-col gap-1 h-full justify-center">
                                            <span class="text-base font-medium">{{ item.coach.name }}</span>
                                            <span class="text-[.8rem] font-medium text-primary">{{ item.coach.position }}</span>
                                            <div class="flex flex-row items-center gap-2">
                                                <IconChartBar :size="18" class="text-gray-400" />
                                                <span class="text-xs text-gray-500">{{ item.coach.expertise }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <a-divider class="my-0"></a-divider>
                                    <div class="flex flex-col gap-5 px-4 py-4">
                                        <div class="flex flex-col gap-3" v-if="isMentorAvailable(item)">
                                            <span class="text-[.8rem] font-medium">Available Date</span>
                                            <div class="flex flex-row flex-wrap gap-2">
                                                <span v-for="schedule in item?.coach?.coach_schedule"
                                                    class="bg-[#f2f2f2] col-span-1 text-light rounded-full px-3 py-1 items-center w-fit h-fit flex text-xs cursor-default"
                                                    :key="schedule">{{ moment(schedule).format('MMM D') }}</span>
                                            </div>
                                        </div>
                                        <!-- <div class="flex flex-col gap-3">
                                            <span class="text-[.8rem] font-medium">Available Time</span>
                                            <div class="flex flex-row gap-2 items-center">
                                                <span v-for="item in availableTime"
                                                    class="bg-[#f2f2f2] text-light rounded-full px-3 py-1 items-center h-fit flex text-xs cursor-pointer"
                                                    :key="item">{{ item }}</span>
                                            </div>
                                        </div> -->
                                        <a-button type="primary" @click="handleDialogBooking(item.coach_id)" shape="round" :disabled="!isMentorAvailable(item)">{{ isMentorAvailable(item) ? 'Book' : 'Not Available' }}</a-button>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="w-full gap-2 flex flex-col items-center justify-center mt-8" v-else>
                                <p>There isn't coach yet.</p>
                            </div>
                        </div>
                    </a-tab-pane>
                </a-tabs>
            </div>
            <div class="flex flex-col col-span-12 md:col-span-4">
                <div class="w-full px-6 py-8 rounded-xl flex border flex-col gap-8">
                    <span class="text-sm font-medium">Program Timeline :</span>
                    <a-timeline>
                        <a-timeline-item :color="moment().isSameOrAfter(moment(timeline.event_date), 'day') ? 'green' : 'gray'" v-for="timeline in JSON.parse(programDetail?.timeline)" :key="timeline">
                            <div class="flex flex-col text-xs gap-1">
                                <span class="text-lg font-semibold">{{ timeline.event_title }}</span>
                                <span>{{ defaultFormatDate(timeline.event_start_date) }} - {{ defaultFormatDate(timeline.event_end_date) }}</span>
                            </div>
                        </a-timeline-item>
                    </a-timeline>
                </div>
            </div>
        </div>
        <a-modal v-model:open="dialogBooking" :width="500" okText="Book" title="Booking Mentoring Session"
            @ok="handleDialogBooking">
            <div class="py-5 w-full flex flex-col gap-6">
                <span>Schedule a one-on-one online session, get your slot!</span>
                <div class="gap-3 flex flex-col w-full">
                    <span class="text-sm font-medium">Select Date</span>
                    <div class="flex flex-row flex-wrap gap-2 items-center w-full">
                        <div v-for="item in availableDate"
                            :class="item === selectedDate ? 'bg-primary text-white' : 'bg-white border text-light'"
                            class="rounded-md h-16 w-16 items-center flex flex-col gap-1 cursor-pointer justify-center"
                            @click="selectedDate = item" :key="item">
                            <span class="text-[.7rem]">{{ moment(item).format('MMM') }}</span>
                            <span class="text-lg font-medium">{{ moment(item).format('D') }}</span>
                        </div>
                    </div>
                </div>
                <div class="gap-3 flex flex-col w-full">
                    <span class="text-sm font-medium">Select Time</span>
                    <div class="flex flex-row flex-wrap gap-2 items-center w-full">
                        <span v-for="item in availableTime"
                            :class="item.id === scheduleId ? 'bg-primary text-white' : 'bg-white border text-light'"
                            class="rounded-full px-3 py-1 items-center h-fit flex text-xs cursor-pointer"
                            @click="scheduleId = item.id" :key="item.id">{{ item.time_start + ' - ' + item.time_end }}</span>
                    </div>
                </div>
            </div>
            <template #footer>
                <div class="w-full flex items-center justify-end">
                    <a-button type="text" class="text-primary" @click="dialogBooking = false">Cancel</a-button>
                    <a-button type="primary" @click="bookNow" :loading="isLoading">Book Now</a-button>
                </div>
            </template>
        </a-modal>
    </layout-internal-container>
</template>

<script setup>
import { ref, onMounted, nextTick, watch } from 'vue';
import DummyProgram from '@/assets/Dummy/program.js';
import axios from '@/plugins/axios';
import {
    IconMoneybag,
    IconExternalLink,
    IconArrowRight,
    IconCloudUpload,
    IconWifi,
    IconCalendarStats,
    IconHeartHandshake,
    IconBuildingEstate,
    IconUsersGroup,
    IconPresentationAnalytics,
    IconChartInfographic,
    IconBrandYoutube,
    IconNotes,
    IconCalendarMonth,
    IconBook,
    IconClockPlay,
    IconSparkles,
    IconVideo,
    IconMessageQuestion,
    IconTerminal2,
    IconMap2,
    IconDiscount,
    IconCoins,
    IconTopologyStar,
    IconAward,
    IconRosetteDiscountCheck,
    IconBriefcaseFilled,
    IconChartBar,
    IconClockHour3Filled,
    IconChevronRight,
    IconChevronDown,
    IconLock,
    IconChecklist,
    IconHourglass,
    IconInfoCircle,
    IconClockCancel
} from '@tabler/icons-vue';
import { message } from 'ant-design-vue';
import { openWebinar } from "@/plugins/constant.ts";
import { useRoute, useRouter } from 'vue-router';
import moment from 'moment';
import DOMPurify from 'dompurify';

// Refs for reactive data
const program = ref(null);
const programDetail = ref(null);
const webinars = ref(null);
const similarProgram = ref(DummyProgram);
const modalApply = ref(false);
const dialogBooking = ref(false);
const modalWebinar = ref(false);
const tab = ref(0);
const categoryCourses = ref([]);
const coaches = ref([]);
const coachId = ref(null);
const availableDate = ref([]);
const availableTime = ref([]);
const selectedDate = ref(null);
const scheduleId = ref(null);
const isLoading = ref(false)

const activeKey = ref([]);

// Using the route to access params and query
const route = useRoute();
const router = useRouter();

watch(() => selectedDate.value, (newValue) => {
    fetchCoachTime();
});

// Methods
const joinWebinar = () => {
    const width = 800;
    const height = 600;
    const left = (window.innerWidth - width) / 2;
    const top = (window.innerHeight - height) / 2;
    const url = `${window.location.origin}/Program/Meeting/` + route.params.ProgramID;
    window.open(
        url,
        '_blank',
        `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
    );
};

const isMentorAvailable = (data) => {
    return data.coach.coach_schedule.length > 0;
};

const isNotAccessibleDate = (category) => {
    return (category?.start_date && moment().isBefore(moment(category.start_date), 'day')) && category.status === 'Not Accessible';
};

const bookNow = async () => {
    try {
        isLoading.value = true;
        
        const formData = new FormData();
        formData.append("schedule_id", scheduleId.value);
        
        const booking = await axios.post('/schedule-booking', formData);

        message.success('Success booking mentor!');

        sessionStorage.setItem('calendarId', booking.data.schedule_id);
        sessionStorage.setItem('calendarType', 'mentoring');

        setTimeout(() => {
            router.push('/internal/calendar');
        }, 1000);
    } catch (error) {
        console.error('Error booking mentor:', error)
        message.error(error?.response?.data?.message || 'Error booking mentor!');
    } finally {
        isLoading.value = false;
    }
}

const sanitizedDesc = (desc) => {
    return DOMPurify.sanitize(desc);
}

const queryMode = () => {
    // Wait for the next DOM update cycle to check the query
    nextTick(() => {
        if (!route.query.mode) return;
        if (route.query.mode === 'apply') {
            modalApply.value = true;
        }
        if (route.query.mode === 'webinar') {
            joinWebinar();
        }
    });
};

const fetchProgramDetail = async () => {
    try {
        const response = await axios.get('/program/' + route.params.ProgramID);
        
        programDetail.value = response?.data

        if (route.params.ProgramID == programDetail.value.id) {
            router.replace({ name: 'InternalProgramDetailScreen', params: { ProgramID: programDetail?.value?.slug } });
        }

        if (route.query.activeKey) {
            const paramActiveKey = route.query.activeKey;
            activeKey.value.push(paramActiveKey);
        }

        if (route?.query?.tab) {
            tab.value = parseInt(route?.query?.tab);
        }
    } catch (error) {
        console.error('Error fetching program:', error)
    }
}

const defaultFormatDate = (date) => {
    return moment(date).format('MMM DD, YYYY');
}

const fetchCourse = async () => {
    try {
        const response = await axios.get('/program/' + route.params.ProgramID + '/course-new');
        
        categoryCourses.value = response?.data
    } catch (error) {
        console.error('Error fetching program:', error)
    }
}

const formatTime = (time) => {
    return moment(time, 'hh:mm A').format('HH:mm');
}

const fetchWebinar = async () => {
    try {
        const response = await axios.get('/program/' + route.params.ProgramID + '/webinar');
        
        webinars.value = response?.data?.data
    } catch (error) {
        console.error('Error fetching webinar:', error)
    }
}

const isBetweenDateTime = (date, timeStart, timeEnd) => {
    return moment().isBetween(
        moment(`${date} ${timeStart}`, 'YYYY-MM-DD hh:mm A'), 
        moment(`${date} ${timeEnd}`, 'YYYY-MM-DD hh:mm A')
    )
};

const isBeforeDateTime = (date, timeStart) => {
    return moment().isBefore(moment(`${date} ${timeStart}`, 'YYYY-MM-DD hh:mm A'))
};

const handleDialogBooking = (coach = null) => {
    dialogBooking.value = false;
    if (coach !== null) {
        dialogBooking.value = true;
        coachId.value = coach;

        fetchCoachDate();
    }
}

const fetchCoach = async () => {
    try {
        const response = await axios.get('/program/' + route.params.ProgramID + '/coach');
    
        coaches.value = response?.data?.data
    } catch (error) {
        console.error('Error fetching mentor:', error)
    }
}

const fetchCoachDate = async () => {
    try {
        const formData = new FormData();
        formData.append("coach_id", coachId.value);
        
        const response = await axios.post('/program/' + programDetail.value.id + '/schedule-date', formData);

        availableDate.value = response?.data
        selectedDate.value = response?.data[0]

        fetchCoachTime();
    } catch (error) {
        console.error('Error fetching mentor date:', error)
    }
}

const fetchCoachTime = async () => {
    try {
        const formData = new FormData();
        formData.append("date", selectedDate.value);
        formData.append("coach_id", coachId.value);

        const response = await axios.post('/program/' + programDetail.value.id + '/schedule-time', formData);

        availableTime.value = response?.data
        scheduleId.value = response?.data[0].time_start
    } catch (error) {
        console.error('Error fetching mentor time:', error)
    }
}


// Fetch data on component mount
onMounted(() => {
    fetchProgramDetail();
    fetchCourse();
    fetchWebinar();
    program.value = DummyProgram.find((t) => `${t.id}` === route.params.ProgramID);
    fetchCoach();
    queryMode();
});

// Exporting directly in script setup doesn't require the `name` field
</script>
